let $teaser_header_addbrand;

function init() {
	$teaser_header_addbrand = $(".js-header-teaser-addbrand");
	$teaser_header_addbrand.each(function () {
		const $this = $(this);

		$this.on("click", () => {
			if (!$this.hasClass("is-active")) {
				$this.addClass("is-active");
				// call method activate brand
			} else {
				$this.removeClass("is-active");
				// call method deactive brand
			}
		});
	});
}

export { init };
